// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import grey from "@material-ui/core/colors/grey"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashBasicComponent>")

const styles = theme => ({

    somestyle: {
        backgroundColor: grey[200]
    },
    
})


class FlashBasicComponent extends Component {
    constructor(props){
        super(props)

        log.debug("constructor(): we supposed to do stuff here now :)")
    }

    state = {
        something: true,
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        const { classes } = this.props

        log.debug("render(): classes =", classes)
        log.debug("render(): state =", this.state)

        return (
            <div>FlashBasicComponent</div>
        )
    }
}


FlashBasicComponent.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "FlashBasicComponent"})(FlashBasicComponent)
